// extracted by mini-css-extract-plugin
export default {"adminDashboard":"admin-dashboard_adminDashboard__SomAG","menu":"admin-dashboard_menu__vR6Iw","dashboardContent":"admin-dashboard_dashboardContent__iycTL"};